import { Dialog, Transition } from "@headlessui/react";
import {
  RideGrid,
  RideGlError,
  RideIconButton,
  RideButton,
} from "@rimac-seguros/ride-system-components";
import React, { Fragment, forwardRef } from "react";
import "./styles.scss";

export const Modal = forwardRef(
  (
    {
      isOpen,
      fullContentOnlyMobile,
      fullContent,
      iconClose = true,
      iconCloseOutside = false,
      backDropClose = true,
      iconCloseText = "Cerrar",
      children,
      className,
      classNameGrid,
      classNameContent,
      classNameContentHead,
      onClose,
      buttonFixed,
    },
    ref
  ) => {
    return (
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          open={isOpen}
          onClose={() => {
            if (backDropClose) {
              onClose?.();
            }
          }}
          className="fixed inset-0 overflow-y-auto new-modal"
          z
          as="div"
          aria-label="Modal title"
        >
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay
              className={`new-modal-overlay fixed w-screen ${
                fullContent ? "" : "bg-ride-sys-color-background-overlay"
              }`}
            />
            <div
              ref={ref}
              className={`new-modal-content absolute w-full overflow-y-auto overflow-x-hidden ${
                fullContent || fullContentOnlyMobile
                  ? "full-content w-screen bg-ride-sys-color-background-default"
                  : "onlyMobile -translate-y-1/2 -translate-x-1/2"
              } ${
                fullContentOnlyMobile
                  ? "onlyMobile -translate-y-1/2 -translate-x-1/2 lg:h-auto lg:w-full lg:bg-transparent"
                  : ""
              } ${classNameContent || ""}`}
            >
              <RideGrid
                className={`${
                  fullContent || fullContentOnlyMobile ? "h-full" : ""
                } ${fullContentOnlyMobile ? "lg:h-full" : ""} ${classNameGrid ||
                  ""}`}
              >
                <div
                  className={`absolute inset-0 col-span-full ${
                    fullContent || fullContentOnlyMobile ? "hidden" : ""
                  } ${fullContentOnlyMobile ? "md:block" : ""}`}
                  onClick={() => onClose?.()}
                ></div>
                <div
                  className={`new-modal-grid relative ${className || ""}`}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div
                    className={`new-modal-button ${
                      fullContent ? "fixed rounded-none" : "absolute"
                    } ${
                      fullContentOnlyMobile
                        ? "fixed only-small:rounded-none lg:absolute"
                        : ""
                    } ${classNameContentHead}`}
                  >
                    {(iconClose || iconCloseOutside) && (
                      <>
                        {iconCloseOutside && (
                          <RideButton
                            text={iconCloseText}
                            variant="text-secondary"
                            type="button"
                            size="large"
                            glyph={<RideGlError />}
                            glyphPosition="right"
                            onClick={() => onClose?.()}
                          />
                        )}
                        {iconClose && !iconCloseOutside && (
                          <RideIconButton
                            glyph={<RideGlError />}
                            variant="unfill"
                            size="large"
                            onClick={() => onClose?.()}
                          />
                        )}
                      </>
                    )}
                  </div>
                  {children}
                </div>
              </RideGrid>
            </div>
            {buttonFixed && buttonFixed}
          </Transition.Child>
        </Dialog>
      </Transition>
    );
  }
);
